export enum TextEvaluationType {
  NoData = 'NoDoneProvided',
  HighScore = 'Correct',
  MediumScore = 'LowAccuracy',
  LowScore = 'VeryLowAccuracy',
}

type TextEvaluationDetails = Record<
  TextEvaluationType,
  { displayLabel: string; color: string; scoreRequirement: number | undefined }
>;

export const textEvaluationDetails: TextEvaluationDetails = {
  [TextEvaluationType.HighScore]: {
    displayLabel: 'Correct',
    color: '#1D656B', // Green
    scoreRequirement: 95,
  },
  [TextEvaluationType.MediumScore]: {
    displayLabel: 'Low Accuracy',
    color: '#F79501', // Orange
    scoreRequirement: 50,
  },
  [TextEvaluationType.LowScore]: {
    displayLabel: 'Very Low Accuracy',
    color: '#F5453B', // Red
    scoreRequirement: 0,
  },
  [TextEvaluationType.NoData]: {
    displayLabel: 'No Done/ Provided',
    color: '#949494', // Grey
    scoreRequirement: undefined, // Indicates no score available
  },
};
